module.exports = __webpack_public_path__ + "images/environment-f6caabc4d76cdb931071e2409f92bef1.jpg";